import { render, staticRenderFns } from "./block-claims-repairer-new.vue?vue&type=template&id=be983674&scoped=true&"
import script from "./block-claims-repairer-new.vue?vue&type=script&lang=js&"
export * from "./block-claims-repairer-new.vue?vue&type=script&lang=js&"
import style0 from "./block-claims-repairer-new.vue?vue&type=style&index=0&id=be983674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be983674",
  null
  
)

export default component.exports